module.exports = __webpack_public_path__ + "components/wind-icon/static/NNE@2x-7e2b24328c438963ad0aaf0d86a56139.png";